// extracted by mini-css-extract-plugin
module.exports = {"background":"AppModal_background_1wF5B","fade":"AppModal_fade_37tJ2"};